module.exports = __webpack_public_path__ + "static/media/banner3.ae25cbc8.jpg";